export default [
    {
		path: '/call/record',
		name: 'CallRecord',
		component: () => import('@/views/call-record/index.vue'),
		meta: {
			title: '通话记录',
            activePath: '/call/record',
		},
	},
	{
		path: '/my/memorandum',
		name: 'Memorandum',
		component: () => import('@/views/memorandum/index.vue'),
		meta: {
			title: '我的备忘',
            activePath: '/my/memorandum',
		},
	},
	{
		path: '/my/comment',
		name: 'Comment',
		component: () => import('@/views/comment/index.vue'),
		meta: {
			title: '我的评论',
            activePath: '/my/comment',
		},
	},
	{
		path: '/my/fastflow',
		name: 'fastflow',
		component: () => import('@/views/fastflow/index.vue'),
		meta: {
			title: '快捷录入',
            activePath: '/my/fastflow',
		},
	},
	{
		path: '/my/followup',
		name: 'Followup',
		component: () => import('@/views/follow-up/index.vue'),
		meta: {
			title: '贷后管理',
            activePath: '/my/followup',
		},
	},
]
